import { useUserQuery } from '@/hooks/react-query/user/use-user'
import { cn } from '@/lib/utils'
import Link from 'next/link'
import { useMemo } from 'react'
import { menuMobileConfig } from '../nav-config'

export const MobileNavFooter = () => {
  const { data } = useUserQuery()

  const isLogin = !!data

  const menu = useMemo(
    () =>
      menuMobileConfig.footer.menu.filter(
        (item) => !(item.href === '/login' && isLogin)
      ),
    [isLogin]
  )

  return (
    <ul>
      {menu.map((item) => (
        <li key={item.href}>
          <Link
            href={item.href}
            className={cn(
              'flex items-center gap-0.5 py-2.5 font-sans text-sm font-normal text-neutral-500',
              item.className
            )}
          >
            {item.title} {item.icon && <item.icon size={16} />}
          </Link>
        </li>
      ))}
    </ul>
  )
}
